// Feature: Live Assist console (PLAN §14). Co-browse over the recording
// stream, audio-only voice via LiveKit, annotations, consent-gated remote
// control, chat, copilot, and assist history.
import { createElement, type ComponentType } from "react";
import { createRoute } from "@tanstack/react-router";
import { registerFeature } from "../registry";
import { LiveAccess, LivePage } from "./LivePage";
import { LiveConsolePage } from "./LiveConsolePage";
import { LiveHistoryPage } from "./LiveHistoryPage";
import "./live.css";

const gated = (page: ComponentType) => () => createElement(LiveAccess, null, createElement(page));

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/live", component: LivePage }),
    createRoute({ getParentRoute: () => appRoute, path: "/live/history", component: gated(LiveHistoryPage) }),
    createRoute({ getParentRoute: () => appRoute, path: "/live/$sessionId", component: gated(LiveConsolePage) }),
  ],
  nav: [{ label: "Live", to: "/live", section: "main", order: 55, scope: "live" }],
});

export { liveApi, agentSocketUrl } from "./api";
export { LiveAgentSocket } from "./socket";
export * from "./model";
export { setVoiceConnector, connectVoice } from "./voice";
